import { render, staticRenderFns } from "./StandardKPIDisplay.vue?vue&type=template&id=31a3f093&lang=pug&"
import script from "./StandardKPIDisplay.vue?vue&type=script&lang=js&"
export * from "./StandardKPIDisplay.vue?vue&type=script&lang=js&"
import style0 from "./StandardKPIDisplay.vue?vue&type=style&index=0&id=31a3f093&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports